class BulkForm extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll("input[type='number']");
    this.totalPrice = this.querySelector(".bulk-order-total");
    this.submit = this.querySelector("button[type='submit']");
    this.qtySpan = this.querySelector(".bulk-qty-total");
    this.rows = this.querySelectorAll("tr");
    this.items = this.querySelector(".items");
    this.resetButton = this.querySelector(".reset");

    this.inputs.forEach((input) => {
      input.addEventListener("input", () => {
        this.updateTotals();
        this.updateItems();
      });

      input.addEventListener("keydown", this.preventNegativeAndDecimalInput);
    });

    this.submit.addEventListener("click", this.submitForm.bind(this));
    this.resetButton.addEventListener("click", this.reset.bind(this));
  }

  preventNegativeAndDecimalInput(event) {
    const keysToPrevent = ['-', 'e', 'E', '.', '+'];

    if (keysToPrevent.includes(event.key)) {
      event.preventDefault();
    }
  }

  submitForm() {
    let formData = {
      items: [],
    };

    const options = {
      firstCallback: function (requestState) {},
      lastCallback: function (requestState) {},
      info: {},
    };

    this.inputs.forEach((input) => {
      if (input.value > 0) {
        formData.items.push({
          id: input.dataset.id,
          quantity: parseFloat(input.value),
        });
      }
    });
    const body = {
      items: formData.items,
    };

    window.liquidAjaxCart.add(body, options);
  }

  updateTotals() {
    let total = 0;
    let qty = 0;
    this.inputs.forEach((input) => {
      if (input.value) {
        const max = parseFloat(input.dataset.max) || 1000;
        const management = input.dataset.management;
        if (parseFloat(input.value) > max && management === "shopify") {
          input.value = max;
        }
        total += parseFloat(input.value) * parseFloat(input.dataset.price);
        qty += parseFloat(input.value);
      }
    });

    if (window.Moonbase.locale.code === "de") {
      let numberFormatter = new Intl.NumberFormat("de-DE", {trailingZeroDisplay: 'stripIfInteger'});

      this.totalPrice.textContent = `${window.Moonbase.currency}` + numberFormatter.format(total);
    }
    else {
      this.totalPrice.textContent = `${window.Moonbase.currency}${total.toFixed(
        2
      )}`;
    }

    this.qtySpan.textContent = qty;

    if(qty > 0) {
      this.resetButton.classList.remove("hidden");
    }
    else {
      this.resetButton.classList.add("hidden");
    }
  }

  updateItems() {
    let html = '';
    this.rows.forEach((row) => {
      const rowInputs = row.querySelectorAll("input[type='number']");
      rowInputs.forEach((input) => {
        if (input.value) {
          const option1 = input.dataset.option1 || '';
          const option2 = input.dataset.option2 || '';
          const sku = input.dataset.sku || '';
          const product_details = input.dataset.productdetails || '';

          const labelParts = [];
          if (option1) labelParts.push(option1);
          if (option2) labelParts.push(option2);
          if (sku) labelParts.push(`SKU: ${sku}`);
          const label = labelParts.join(', ');

          const qty = parseFloat(input.value); // Calculate qty per input
          html += `
            <div class="flex mt-2 gap-2 items-center justify-between">
              <div>${label}</div>
              <div>${qty}</div>
            </div>
          `;
          if (product_details.trim()) {
            html += `<div>${product_details}</div>`;
          }
        }
      });
    });
    this.items.innerHTML = html;
  }

  reset() {
    this.inputs.forEach((input) => {
      input.value = "";
    });
    this.updateTotals();
    this.updateItems();
  }
}

customElements.define("product-bulk-order-form", BulkForm);